import { gql, useQuery } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { LocalizedPromotionOptions } from 'apollo/localizedTypes';

const LIST_PROMOTION_OPTIONS = gql`
  query listPromotionOptions {
    listPromotionOptions {
      entranceTicketTypes {
        name {
          ...LocalizedTextFields
        }
        id
      }
      activityTypes {
        name
        id
      }
      packs {
        name {
          ...LocalizedTextFields
        }
        id
      }
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useQueryListPromotionOptions = () => {
  return useQuery<{ listPromotionOptions: LocalizedPromotionOptions }>(
    LIST_PROMOTION_OPTIONS,
    {}
  );
};

export default useQueryListPromotionOptions;
